import React from "react";
import { makeStyles, Fab, Box, Typography } from "@material-ui/core";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import { Link as ScrollLink } from "react-scroll";

function ScrollToTop(props) {
  const useStyles = makeStyles((theme) => ({
    scrollArrow: {
      color: theme.palette.primary.contrastText,
    },
  }));

  const classes = useStyles();

  return (
    <Box
      className={
        "d-flex flex-column align-items-" +
        (isWidthUp("lg", props.width) ? "end" : "center")
      }
      style={{
        paddingBottom: 15,
      }}
    >
      <span
        className="d-flex flex-column align-items-center"
        style={{
          width: "min-content",
        }}
      >
        <ScrollLink to="NavBar" spy={true} smooth={true} duration={500}>
          <Fab color="secondary" className={classes.scrollIcon}>
            <ArrowUpwardIcon className={classes.scrollArrow} color="primary" />
          </Fab>
        </ScrollLink>
        <Typography
          style={{ display: "block", paddingTop: 15 }}
          variant="subtitle2"
        >
          Go To Top
        </Typography>
      </span>
    </Box>
  );
}

export default withWidth()(ScrollToTop);
